import { getEventActionName } from "../../core/make-action";
import ViewerEvent from "../../core/ViewerEvent";

const initialState = {
  location: {},
  text: "",
  highlight: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case getEventActionName(ViewerEvent.SELECTION_MADE):
      return {
        ...state,
        text: action.eventData.selectedText,
        location: action.eventData.eventPosition,
        highlight: null,
      };
    case getEventActionName(ViewerEvent.HIGHLIGHT_CLICK):
      return {
        ...state,
        text: action.eventData.highlight?.selectedText,
        location: action.eventData.position,
        highlight: action.eventData.highlight,
      };
    case getEventActionName(ViewerEvent.SELECTION_CANCELLED):
      return initialState;
    default:
      return state;
  }
}
